import React from 'react';
import { apTheme } from '../../utils/agentPlatformTheme';

type Props = {
  children: React.ReactNode;
};

export const AgentPlatformTableActionsCell: React.FC<Props> = ({ children }) => (
  <td className={apTheme.tableActionsCell}>
    <div className={apTheme.tableActionsGroup}>{children}</div>
  </td>
);
